import React, { useState } from 'react';
import approx from 'approximate-number';
import { Loader, Dimmer, Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { downloadCSVFile } from '../../../../actions/report';

export default function ReportTile(props) {
  const [waitingForDownload, setWaitingForDownload] = useState(false);

  const generateNumForDisplay = (originalNum, hasTwoColumn) => {
    let numAbbrev = approx(originalNum, { capital: true });
    let lastChar = numAbbrev.slice(numAbbrev.length - 1, numAbbrev.length);
    let firstSplitPart = numAbbrev.slice(0, numAbbrev.length - 1);
    if (lastChar.match(/[0-9]/)) {
      // If has decimal point, show 1 decimal place
      if (originalNum != parseInt(originalNum)) {
        return <div>{parseFloat(originalNum).toFixed(1).toString()}</div>;
      } // If it is integer, show as it is
      else {
        return <div>{numAbbrev}</div>;
      }
    } else {
      let lastDigit = firstSplitPart.slice(firstSplitPart.length - 1, firstSplitPart.length);
      if (lastDigit === '1')
        return (
          <div>
            {/* TODO: Use new names when they are merged */}
            <Container fluid as={Media} greaterThanOrEqual="tablet">
              <div className="spanlike">{firstSplitPart}</div>
              <div className="spanlike push-left text-size-xxl">{lastChar}</div>
            </Container>
            <Container fluid as={Media} at="mobile">
              {numAbbrev}
            </Container>
          </div>
        );
      return (
        <div>
          {/* TODO: Use new names when they are merged */}
          <Container fluid as={Media} greaterThanOrEqual="tablet">
            <div className="spanlike">{firstSplitPart}</div>
            <div className="spanlike text-size-xxl">{lastChar}</div>
          </Container>
          <Container fluid as={Media} at="mobile">
            {numAbbrev}
          </Container>
        </div>
      );
    }
  };

  const downloadCSV = (url) => {
    setWaitingForDownload(true);

    let cb = () => {
      setWaitingForDownload(false);
    };
    downloadCSVFile(url, cb);
  };

  let centralSection = '';
  let centralSectionInSmallView = '';
  if (props.entries.length == 3) {
    let innercentralSection = props.entries.map((entry, index) => {
      return (
        <div className={index === 1 ? 'row-figures mrbl min-height-second-line' : 'row-figures mrbl'} key={index}>
          <div className={entry[1] == true ? 'waiting-area-green value mrbm' : 'color-light-black value mrbm'}>
            <div className="val-num">{generateNumForDisplay(entry[2])}</div>
          </div>
          <div className="color-light-black label">{entry[0]}</div>
        </div>
      );
    });
    centralSection = <div className="central-block-container hide-on-small-devices mrtl">{innercentralSection}</div>;

    let innercentralSectionInSmallView = props.entries.map((entry, index) => {
      return (
        <div className="row-figures mrbxxs" key={index}>
          <span className={entry[1] == true ? 'waiting-area-green value' : 'color-light-black value'}>
            {generateNumForDisplay(entry[2])}
          </span>
          {entry[0]}
        </div>
      );
    });

    centralSectionInSmallView = (
      <div className="central-block-container show-on-small-devices mrtl mrbl">{innercentralSectionInSmallView}</div>
    );
  } else if (props.entries.length == 4) {
    centralSection = (
      <div className="central-block-container hide-on-small-devices mrtl">
        <div className="row-figures mrbl">
          <div
            className={props.entries[0][1] == true ? 'waiting-area-green value mrbm' : 'color-light-black value mrbm'}
          >
            <div className="val-num">{generateNumForDisplay(props.entries[0][2])}</div>
          </div>
          <div className="color-light-black label">{props.entries[0][0]}</div>
        </div>
        <div className="row-figures mrbl display-flex min-height-second-line">
          <div className="inline-figure-block pdlxxs">
            <div
              className={props.entries[1][1] == true ? 'waiting-area-green value mrbm' : 'color-light-black value mrbm'}
            >
              <div className="val-num">{generateNumForDisplay(props.entries[1][2], true)}</div>
            </div>
            <div className="color-light-black label">{props.entries[1][0]}</div>
          </div>
          <div className="inline-figure-block pdrxxs">
            <div
              className={props.entries[2][1] == true ? 'waiting-area-green value mrbm' : 'color-light-black value mrbm'}
            >
              <div className="val-num">{generateNumForDisplay(props.entries[2][2], true)}</div>
            </div>
            <div className="color-light-black label">{props.entries[2][0]}</div>
          </div>
        </div>
        <div className="row-figures mrbl">
          <div
            className={props.entries[3][1] == true ? 'waiting-area-green value mrbm' : 'color-light-black value mrbm'}
          >
            <div className="val-num">{generateNumForDisplay(props.entries[3][2])}</div>
          </div>
          <div className="color-light-black label">{props.entries[3][0]}</div>
        </div>
      </div>
    );

    let innercentralSectionInSmallView = props.entries.map((entry, index) => {
      return (
        <div className="row-figures mrbxxs" key={index}>
          <span className={entry[1] == true ? 'waiting-area-green value' : 'color-light-black value'}>
            {generateNumForDisplay(entry[2])}
          </span>
          {entry[0]}
        </div>
      );
    });

    centralSectionInSmallView = (
      <div className="central-block-container show-on-small-devices mrts mrbs">{innercentralSectionInSmallView}</div>
    );
  }

  return (
    <div className="ui report-tile shape pdrs mrbm invisible-to-full" data-show={props.isShow}>
      <div className="sides">
        <div className="active side">
          <div className="ui card border-radius-null borderless main-report-card" data-opaque={props.opaqued}>
            <div className="content main-report-statistics" data-is-filtered={false}>
              <span className={props.colourTheme + ' report-title-bar color-white'}>
                <div className="statistic mrbm">
                  <div className="header pdrxs pdlxs">{props.renderedTile}</div>
                </div>
              </span>
              {centralSection}
              {centralSectionInSmallView}
              {props.canDownload && !waitingForDownload ? (
                <div
                  className="mid-bottom-info-container report color-light-gray-bg downloadable"
                  onClick={(event) => {
                    downloadCSV(props.csvUrl);
                  }}
                >
                  <div className="download-label color-info-mid-grey mrrs">DOWNLOAD REPORT (CSV)</div>
                  <i className="download icon download-icon color-info-mid-grey" />
                </div>
              ) : (
                <>
                  {waitingForDownload ? (
                    <div className="mid-bottom-info-container report color-light-gray-bg">
                      <Container fluid as={Media} greaterThanOrEqual="tablet" data-show={waitingForDownload}>
                        <Dimmer className="color-light-gray-bg loder-dimmer" inverted active>
                          <Loader active size="small" inline="centered" />
                        </Dimmer>
                      </Container>
                      <Container fluid as={Media} at="mobile" data-show={waitingForDownload}>
                        <Dimmer className="bg-transparent loder-dimmer" inverted active>
                          <Loader
                            size="small"
                            className="ui active transition visible bg-transparent loader mobile-loader"
                          />
                        </Dimmer>
                      </Container>
                    </div>
                  ) : (
                    <div className="mid-bottom-info-container report color-light-gray-bg">
                      <Container fluid as={Media} greaterThanOrEqual="tablet" data-show={waitingForDownload}>
                        <Dimmer className="color-light-gray-bg loder-dimmer" inverted active />
                      </Container>
                      <Container fluid as={Media} at="mobile" data-show={waitingForDownload}>
                        <Dimmer className="bg-transparent loder-dimmer" inverted active />
                      </Container>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
